import { lazyload } from 'react-lazyload'

export default component =>
  lazyload({
    height: 300,
    offset: 100,
  })(component)
